module.exports = __webpack_public_path__ + "static/media/mode-26.00d4178a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-26.svg
// module id = 999
// module chunks = 2